import CREATE_MESSAGE from '../actions/messagesActions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};
